import { render, staticRenderFns } from "./PackageReportDetail.vue?vue&type=template&id=d04756ae&scoped=true"
import script from "./PackageReportDetail.vue?vue&type=script&lang=js"
export * from "./PackageReportDetail.vue?vue&type=script&lang=js"
import style0 from "./PackageReportDetail.vue?vue&type=style&index=0&id=d04756ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04756ae",
  null
  
)

export default component.exports